module.exports = __webpack_public_path__ + "img/qpm@2x.527a70b8.png";